import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import '~a/css/main.scss'
import '~a/css/goodsList.css'

import router from './router'
import store from './store'
import vuescroll from "vue-scroll";
Vue.use(vuescroll, { debounce: 600 });
Vue.config.productionTip = false




//使用自用插件
import plugin from "./plugin"
Vue.use(plugin,{
  silent:process.env.NODE_ENV !== "development"
})


new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
